import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-multi-lang";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { client, clientsSlice, clientsState } from "./ClientsSlice";

import { useLocation } from "react-router-dom";

//page name

import { getPageName } from "../../components/Nav/PageName";

// API
import ClientApi from "../../services/api/clients";
import OtherApi from "../../services/api/other";

// Components
import TableActionBar from "../../components/TableActionBar/TableActionBar";
//import { DashboardTable } from "../../components/Table/TableClassic";
import { DashboardTable } from "../../components/Table/TablePagination";
import { EllipsisLoader, WhiteboxLoader } from "../../components/Loader/Loader";
import { Link } from "react-router-dom";

import "./Clients.css";
import { ClassesMenu } from "../../components/PredefinedMenus/PredefinedMenus";
import { PageSizeSelect, SelectField } from "../../components/FormElements/FormElements";
import { years } from "../../services/hoc/helpers";
import { toast } from "react-toastify";
import select_vector from "../../assets/images/vectors/select.svg";

interface IProps {
  category: "facility" | "financial";
  offbalance?: boolean;
  bank?: number;
  type?: "limits";
}

export default (props: IProps) => {
  // debugger;
  // Translation
  const t = useTranslation();

  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { clients: clientsState }) => state.clients
  );

  const currentPage = state.currentPage;
  const lastPage = state.lastPage;
  const pagesCount = state.pagesCount;

  const [pageSize, setPageSize] = useState<number>(10);
  // Hooks
  const [keyword, setKeyword] = useState<string>("");
  const [classType, setClassType] = useState<any>();
  const [year, setYear] = useState<number>();
  const [quarter, setQuarter] = useState<"q1" | "q2" | "q3" | "q4">();
  const [classes, setClasses] = useState<any[]>([]);
  const [ecl, setEcl] = useState<boolean>();
  // API
  const ENDPOINTS = new ClientApi();
  const OTHERENDPOINTS = new OtherApi();
  // Table ref
  type TableHandle = React.ElementRef<typeof DashboardTable>;
  const tableRef = useRef<TableHandle>(null);

  const searchEcl = () => {
    if (year && quarter) {
      setEcl(true);
    } else {
      toast("You need Select Year and  Quarter .", {
        progressStyle: { background: "tomato" },
      });
    }
  }

  function getBalanceValue(res: any): number {
    return (
      res?.onBalanceOutstanding ??
      res?.limitOutstanding ??
      res?.offBalanceOutstanding ??
      res?.total_outstanding_lcy
    );
  }

  // Search
  const search = (value: string) => {
    ENDPOINTS.abortCalls();
    tableRef.current?.reset();
    dispatch(clientsSlice.actions.reset());
    setKeyword(value);
  };

  // Fetch Data
  const fetchData = (page: number, page_size: number = 10) => {
    console.log('Fetching data with props:', {
      category: props.category,
      offbalance: props.offbalance,
      bank: props.bank,
      type: props.type,
      classType: classType?.value,
      year,
      quarter,
      ecl
    });
    
    dispatch(clientsSlice.actions.setCurrentPage(page));
    dispatch(clientsSlice.actions.setIsFetching(true));

    ENDPOINTS.clients()
      .index({
        page,
        page_size,
        class_type_category: props.category,
        //classType?.value ? undefined :
        class_type_id: classType?.value,
        year,
        quarter,
        type: props.offbalance ? "documents" : undefined,
        limit: props.type === "limits" ? "yes" : undefined,
        ecl: ecl
      })
      .then((response: any) => {
        let clients: client[] =
          props.bank == 1
            ? response.data.data.clients
                .filter((client: any) => client.class_type_id == "7")
                .map(
                  (client: any): client => ({
                    id: client.id,
                    loan_key: client.loan_key,
                    cif: client.cif == "0" ? "00000" : client.cif,
                    name: client.name,
                    class_type: client.class_type_name,
                    type: client.type,
                    total_outstanding_lcy: client.banksOutstanding,
                    ecl: client.onecl
                  })
                )
            : props.bank == 2
            ? response.data.data.clients
                .filter((client: any) => client.class_type_id != "7")
                .map(
                  (client: any): client => ({
                    id: client.id,
                    loan_key: client.loan_key,
                    cif: client.cif == "0" ? "00000" : client.cif,
                    name: client.name,
                    class_type: client.class_type_name,
                    type: client.type,
                    total_outstanding_lcy: client.banksOutstanding,
                    ecl: client.onecl
                  })
                )
            : response.data.data.clients.map(
                (client: any): client => ({
                  id: client.id,
                  loan_key: client.loan_key,
                  cif: client.cif == "0" ? "00000" : client.cif,
                  name: client.name,
                  class_type: client.class_type_name,
                  type: client.type,
                  total_outstanding_lcy: getBalanceValue(client),
                  ecl: client.ecl
                })
              );
        // debugger;
        dispatch(
          clientsSlice.actions.setPagesCount(
            Number(response.data.data.pages_count)
          )
        );
        dispatch(clientsSlice.actions.addClients(clients));
        dispatch(
          clientsSlice.actions.setHasMore(
            page < Number(response.data.data.last_page)
          )
        );
        if (!state.isLoaded) dispatch(clientsSlice.actions.setIsLoaded(true));
      });
  };

  interface tableDataType {
    [key: string]: { [key: string]: any };
  }
  const generateData: () => tableDataType = () => {
    let data: tableDataType = {};
    state.clients.map((client, index) => {
      console.log(client);
      data[client.id] = {
        actions1: <div className="SimpleCheckbox">
          <input
            type="checkbox"
            value={client.cif}
            checked={state.selectedClients.includes(client.cif)}
            onChange={() =>
              dispatch(clientsSlice.actions.toggleClientSelection(client.cif))
            }
          />
        </div>,
        serial: index + 1,
        cif: client.cif,
        name: client.name,
        class_type: client.class_type,
        outstanding_lcy: client.total_outstanding_lcy,
        ecl: ecl ? client.ecl : 0,
        actions: (
          <div className="show-on-hover">
            <Link
              target="_blank"
              to={
                `/search-client?cif=${client.cif}` +
                (year ? `&year=${year}` : "") +
                (quarter ? `&quarter=${quarter}` : "") +
                (props.type === "limits" ? "&limits=yes" : "") +
                (props.offbalance ? "&client_type=offbalance" : "")
              }
            >
              <i className="icon-information" style={{ color: "#333" }} />
            </Link>
          </div>
        ),
      };
    });

    return data;
  };

  // First fetch - load classes
  useEffect(() => {
    // debugger;
    if (state.isLoaded || state.isFetching) return;
    OTHERENDPOINTS.other()
      .predefined()
      .then((response: any) => {
        setClasses(response.data?.data?.class_types);
      });
    return () => {
      dispatch(clientsSlice.actions.setIsLoaded(false));
      dispatch(clientsSlice.actions.setIsFetching(false));
    };
  }, []);

  // Watch for classType and fetch data
  useEffect(() => {
    setEcl(undefined);
    if (!state.isLoaded && classes?.length > 0) fetchData(1);
  }, [classes, classType]);

  // Watch for filter changes and reset
  useEffect(() => {
    ENDPOINTS.abortCalls();
    tableRef.current?.reset();
    dispatch(clientsSlice.actions.reset());
    // Fetch data after reset if classType is selected
    if (classType && classes?.length > 0) {
      fetchData(1);
    }
  }, [classType, year, quarter, props.offbalance, location.href, ecl]);

  // Watch for category changes and reset
  useEffect(() => {
    ENDPOINTS.abortCalls();
    setClassType(null);
    setEcl(undefined);
    tableRef.current?.reset();
    dispatch(clientsSlice.actions.reset());
    // Fetch data after reset if classes are loaded
    if (classes?.length > 0) {
      fetchData(1);
    }
  }, [props.category]);

  // *** FIX: Watch for props changes that should trigger data fetch ***
  useEffect(() => {
    // Don't fetch if no classType selected
    if (!classType) return;
    
    console.log('Props changed, fetching new data:', {
      category: props.category,
      offbalance: props.offbalance,
      bank: props.bank,
      type: props.type
    });
    
    // Reset and fetch
    ENDPOINTS.abortCalls();
    tableRef.current?.reset();
    dispatch(clientsSlice.actions.reset());
    fetchData(1);
    
  }, [props.category, props.offbalance, props.bank, props.type]);

  const pageLocation = useLocation();
  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    const currentUrl = pageLocation.pathname;
    const name = getPageName(currentUrl);
    if (name) {
      setPageTitle(name);
    } else {
      setPageTitle("Unknown Page");
    }
  }, [pageLocation.pathname]);

  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading ? <WhiteboxLoader /> : ""}
          <form>
            <div className="filters">

              <div className="filter" key={props.category}>
                {" "}
                <ClassesMenu
                  isClearable
                  value={classType}
                  onChange={(selected: any) => setClassType(selected)}
                  placeholder={t("class_type")}
                />
                {/* <SelectField
                  isClearable
                  placeholder={t('class_type')}
                  value={classType}
                  onChange={(selected: any) => setClassType(selected)}
                  options={classes.filter(
                    (item: any) => item.category === props.category,
                  )}
                  getOptionLabel={(item: any) => item.name}
                  getOptionValue={(item: any) => item.id}
                /> */}
              </div>
              <div className="filter">
                <SelectField
                  isClearable
                  defaultValue={year ? { label: year, value: year } : null}
                  onChange={(selected: { value: number }) =>
                    setYear(selected?.value)
                  }
                  placeholder={t("year")}
                  options={years}
                />
              </div>
              <div className="filter">
                <SelectField
                  isClearable
                  defaultValue={
                    quarter
                      ? { label: quarter?.toUpperCase(), value: quarter }
                      : null
                  }
                  onChange={(selected: { value: "q1" | "q2" | "q3" | "q4" }) =>
                    setQuarter(selected?.value)
                  }
                  placeholder={t("quarter")}
                  options={[
                    { label: "Q1", value: "q1" },
                    { label: "Q2", value: "q2" },
                    { label: "Q3", value: "q3" },
                    { label: "Q4", value: "q4" },
                  ]}
                />
              </div>

              <div className="filter"><button
                type="button"
                className="button bg-gold color-white round"
                style={{ width: 200 }}
                onClick={() => {
                  if (!year || !quarter) {
                    toast("You need Select Year and Quarter.", {
                      progressStyle: { background: "tomato" },
                    });
                    return;
                  }

                  setEcl(true);
                }}
              >
                Calculate ECL
              </button>
              </div>
            </div>
          </form>

          <TableActionBar
            title={pageTitle}
            search={search}
            showFilter={false}
          />

          {/* { <DashboardTable
            ref={tableRef}
            header={["serial", t("cif"), t("name"), t("class_type") ,"Outstanding", "ecl",""]}
            body={generateData()}
            hasMore={state.hasMore}
            loadMore={fetchData}
          /> } */}
          {Object.keys(generateData()).length > 0 ? (
            <DashboardTable
              ref={tableRef}
              header={[
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <input
                    type="checkbox"
                    checked={
                      state.clients.length > 0 &&
                      state.clients.every((client) =>
                        state.selectedClients.includes(client.cif)
                      )
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        dispatch(clientsSlice.actions.selectAllClients());
                      } else {
                        dispatch(clientsSlice.actions.unselectAllClients());
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  />
                  <label style={{ margin: 0 }}>{t("Select")}</label>
                </div>,
                "serial", t("cif"), t("name"), t("class_type"), "Outstanding", "ecl", ""
              ]}
              body={generateData()}
              selectable
              onSelect={() => { }}
              loadMore={(page: number) => fetchData(page)}
              pagesCount={pagesCount}
            />
          ) : (
            <div className="center">
              <br /> <br /> <br /> <br />
              <br /> <br />
              <br /> <br />
              <img src={select_vector} style={{ maxWidth: 500 }} />
              <p>Please select all filters</p>
            </div>
          )}
          {/* Pagination footer */}
          {Object.keys(generateData()).length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  width: 70,
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  position: "relative",
                  top: "-45px",
                  marginLeft: "250px",
                }}
              >
                <PageSizeSelect
                  value={pageSize}
                  onChange={(val: number) => {
                    setPageSize(val);
                    tableRef.current?.reset();
                    fetchData(1, val);
                  }}
                  options={[
                    { label: "10", value: 10 },
                    { label: "20", value: 20 },
                    { label: "30", value: 30 },
                    { label: "50", value: 50 },
                    { label: "100", value: 100 },
                  ]}
                />
              </div>
            </div>
          )}

        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};